module.exports = __webpack_public_path__ + "595a0953514c8264e533168b9bdc068b.pdf";